import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { PushMessage } from "./messages";
import { incrementFabric } from "@/utils/incrementId";


type PushState = {
  messages: Record<string, PushMessage>
}

const initialState = {
  messages: {},
} satisfies PushState as PushState;

const incrementPushId = incrementFabric(0, 'Push');

export const pushSlice = createSlice({
  name: 'push',
  initialState,
  reducers: {
    addPushMessage(state, action: PayloadAction<PushMessage>) {
      const id = incrementPushId();
      state.messages[id] = action.payload;
    },
    deletePushMessage(state, action: PayloadAction<string>) {
      delete state.messages[action.payload];
    }
  },
  selectors: {
    selectMessages: (state) => state.messages,
  }
});

export const { addPushMessage, deletePushMessage } = pushSlice.actions;
export const { selectMessages } = pushSlice.selectors;
